import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  makeStyles, Button,
} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Stack } from '@mui/material';
import { api_call, empty } from '../helpers/untils';
import UserMaintDoneModal from './UserMaintDoneModal';
import UserMaintSnoozeModal from './UserMaintSnoozeModal';

const useStyles = makeStyles((theme) => ({
  bluetoothModal: {
    // width: '600px',
  },
}));

const UserMaintActionDialog = (props) => {
  const { open, setOpen, history, device, item, showToast, itemList, setItemList } = props;
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  }

  const [userMaintDoneModalOpen, setUserMaintDoneModalOpen] = useState(false);
  const [userMaintSnoozeModalOpen, setUserMaintSnoozeModalOpen] = useState(false);

  const [currentAction, setCurrentAction] = useState('');

  const onClickAction = (actionType = '') => { // actionType: done, ignore, snooze
    setCurrentAction(actionType);
    submitkAction(actionType);
    if (actionType === 'done') {
      setUserMaintDoneModalOpen(true);
    }
    if (actionType === 'snooze') {
      setUserMaintSnoozeModalOpen(true);
    }
  }

  const submitkAction = async (actionType, params = {}) => { // actionType: done, ignore, snooze
    if (empty(actionType)) {
      actionType = currentAction;
    }
    console.log(`onClickAction:::, device`, actionType, params, device, `item`, item);
    const url = `/api/user-maint`;
    const payload = {
      maintId: item.id,
      deviceId: item.deviceId,
      action: actionType,
      ...params
    }
    const response = await api_call(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      const responseObj = await response.json();
      if (responseObj['maintItemList']) {
        setItemList(responseObj['maintItemList']);
      }
    }
  }

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        {/* <DialogTitle>Select Command</DialogTitle> */}
        <Stack direction={`column`} spacing={2} style={{ padding: '16px', width: '200px' }}>
          <Button variant='outlined' color='secondary' onClick={() => onClickAction('done')} disabled={item?.user_action === 'done' || item?.user_action === 'ignore'}>Done</Button>
          <Button variant='outlined' color='secondary' onClick={() => onClickAction('ignore')} disabled={item?.user_action === 'done' || item?.user_action === 'ignore'}>Ignore</Button>
          <Button variant='outlined' color='secondary' onClick={() => onClickAction('snooze')} disabled={item?.user_action === 'done' || item?.user_action === 'ignore'}>Snooze</Button>
        </Stack>
      </Dialog>
      <>
        <UserMaintDoneModal
          open={userMaintDoneModalOpen}
          setOpen={setUserMaintDoneModalOpen}
          maintItem={item}
          deviceItem={device}
          history={history}
          showToast={showToast}
          onSuccess={() => {
            setUserMaintDoneModalOpen(false);
            setOpen(false);
            showToast("Maintenance marked as done");
          }}
        />
      </>
      <>
        <UserMaintSnoozeModal
          open={userMaintSnoozeModalOpen}
          setOpen={setUserMaintSnoozeModalOpen}
          maintItem={item}
          deviceItem={device}
          history={history}
          showToast={showToast}
          onSuccess={() => {
            setUserMaintSnoozeModalOpen(false);
            setOpen(false);
            showToast("Maintenance marked as snoozed");
          }}
        />
      </>

    </>
  )
}

export default UserMaintActionDialog;
